import React, { createContext, useState, ReactNode } from 'react';
import { TaskInstance } from '../../types/interfaces';

interface Event {
  details: TaskInstance | null;
}

export interface CalendarContextType {
  selectedEvent: Event | null;
  setSelectedEvent: React.Dispatch<React.SetStateAction<Event | null>>;
}

// Definiendo datos por defecto para el evento
const defaultEvent: Event = {
  details: null,
};

const defaultCalendarContextValue: CalendarContextType = {
  selectedEvent: defaultEvent, // Usando el evento por defecto
  setSelectedEvent: () => {}, // Función vacía, será sobrescrita por el useState en el provider
};

const CalendarContext = createContext<CalendarContextType>(
  defaultCalendarContextValue
);

interface CalendarProviderProps {
  children: ReactNode;
}

export const CalendarProvider: React.FC<CalendarProviderProps> = ({
  children,
}) => {
  const [selectedEvent, setSelectedEvent] = useState<Event | null>(
    defaultEvent
  );

  return (
    <CalendarContext.Provider value={{ selectedEvent, setSelectedEvent }}>
      {children}
    </CalendarContext.Provider>
  );
};

export default CalendarContext;
